import { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
//
import * as location from '~store/location/thunks';
import { resetLocation } from '~store/location/slice';

const useLocations = ({ province, city }) => {
  const dispatch = useDispatch();
  const { current } = useRef({ provinceId: '', cityId: '' });
  const { countries, provinces, cities, districts } = useSelector(
    (state) => state.location,
  );

  // mounted
  useEffect(() => {
    try {
      dispatch(location.countries({ name: 'Indonesia' }));
      dispatch(location.provinces());
    } catch (error) {}
  }, [dispatch]);
  useEffect(() => {
    try {
      if (province.id && province.id !== current.provinceId) {
        dispatch(
          location.cities({
            province_id: province.id,
            fields: 'name type',
            sort: 'name',
          }),
        );
        current.provinceId = province.id;
      } else {
        dispatch(resetLocation('cities'));
      }
    } catch (error) {}
  }, [dispatch, province.id]);

  // cities
  useEffect(() => {
    try {
      if (city.id && city.id !== current.cityId) {
        dispatch(
          location.districts({
            city_id: city.id,
            fields: 'name type',
            sort: 'name',
          }),
        );
        current.cityId = city.id;
      } else {
        dispatch(resetLocation('districts'));
      }
    } catch (error) {}
  }, [dispatch, city.id]);
  //
  return { countries, provinces, cities, districts };
};

export default useLocations;
